export const CELL_HEIGHT = {
  Desktop: 200,
  Mobile: 130,
};
export const MAX_IMAGES_PER_COL = 4;
export const COL_SPACING = 2;
